import API from "@/services/apiservices";
import Vue from "vue";

export function routeGuard(to, from, next) {
  // if (Vue.$cookies.get("login")) {
  // console.log("routeGuard.to:", to);
  // console.log("routeGuard:", to.fullPath);
  // console.log("routeGuard.prop:", to.matched[0].props.default.homepage || "não");

  if (to.matched[0].props && to.matched[0].props.default && to.matched[0].props.default.homepage) {
    API.sethomepage(to);
  }

  //if (sessionStorage.getItem("token")) {
  if (Vue.$cookies.get("token") && Vue.$cookies.get("token") !== "") {

    const path = '/' + to.fullPath.split('?')[0].split('/')[1];

    API.get('Servicos/APISolucoesMenus/Get', { params: { route: path } }, false).then((res) => {
      const data = API.prepareData(res);
      console
      if (data.success) {
        if (data.data[0].Manutencao) {
          next({path: "/manutencao"})
        } else {
          if (data.data[0].Atualizacao) {
            next({path: "/atualizacao"})          
          } else {
            next();
          }
        }
      } else {
        next()
      }
    })

  } else {
    API.logout();
    next({ name: "Login", query: { redir: to.fullPath.replace("/", "") } });
  }
}
